import { useMemo } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/RecoveryPassword/RecoveryPassword.module.scss'
import { Button } from '@src/components/Button/Button'
import { phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { AppDispatch } from '@src/store/store'
import { recoveryPasswordFirstStep } from '@src/store/ducks/auth/thunks'
import { selectBackError } from '@src/store/ducks/auth/selectors'

export const RecoveryPasswordFirstForm = () => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      userPhone: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
    })
  ), [])

  const initialValues = useMemo(() => ({
    userPhone: '',
  }), [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ userPhone }) => {
        dispatch(recoveryPasswordFirstStep(userPhone))
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <div className={style.firstForm}>
            <FieldFormik
              name="userPhone"
              placeholder="Номер телефона"
              mask="+{375} (00) 000-00-00"
            />
            {backError && String(backError) && (
              <div className={style.error}>
                *
                {backError}
              </div>
            )}
          </div>
          <div className={style.btnBlock}>
            <Button
              htmlType="submit"
              type="secondary"
              className={style.btnSize}
            >
              Отправить
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
